import { HttpErrorResponse } from '@angular/common/http';

import { Action } from '@ngrx/store';

import { IMemberProfileTraveller } from '@shared/shared/interfaces/member-profile-traveller.interfaces';

// Create traveller
export const CREATE_PROFILE_TRAVELLER = '[Member Profile] Create Profile Traveller';
export const CREATE_PROFILE_TRAVELLER_SUCCESS = '[Member Profile] Create Profile Traveller Success';
export const CREATE_PROFILE_TRAVELLER_FAIL = '[Member Profile] Create Profile Traveller Fail';

export class CreateProfileTraveller implements Action {
  readonly type = CREATE_PROFILE_TRAVELLER;
  constructor(public payload: IMemberProfileTraveller) {}
}

export class CreateProfileTravellerSuccess implements Action {
  readonly type = CREATE_PROFILE_TRAVELLER_SUCCESS;
  constructor(public payload: IMemberProfileTraveller) {}
}

export class CreateProfileTravellerFail implements Action {
  readonly type = CREATE_PROFILE_TRAVELLER_FAIL;
}

// Destroy traveller
export const DESTROY_PROFILE_TRAVELLER = '[Member Profile] Destroy Profile Traveller';
export const DESTROY_PROFILE_TRAVELLER_SUCCESS = '[Member Profile] Destroy Profile Traveller Success';
export const DESTROY_PROFILE_TRAVELLER_FAIL = '[Member Profile] Destroy Profile Traveller Fail';

export class DestroyProfileTraveller implements Action {
  readonly type = DESTROY_PROFILE_TRAVELLER;
  constructor(public payload: number) {}
}

export class DestroyProfileTravellerSuccess implements Action {
  readonly type = DESTROY_PROFILE_TRAVELLER_SUCCESS;
  constructor(public payload: number) {}
}

export class DestroyProfileTravellerFail implements Action {
  readonly type = DESTROY_PROFILE_TRAVELLER_FAIL;
  constructor(public error: HttpErrorResponse) {}
}

// Update traveller
export const UPDATE_PROFILE_TRAVELLER = '[Member Profile] Update Profile Traveller';
export const UPDATE_PROFILE_TRAVELLER_SUCCESS = '[Member Profile] Update Profile Traveller Success';
export const UPDATE_PROFILE_TRAVELLER_FAIL = '[Member Profile] Update Profile Traveller Fail';
export const UPDATE_MULTIPLE_PROFILE_TRAVELLER = '[Member Profile] Update Multiple Profile Traveller';

export class UpdateProfileTraveller implements Action {
  readonly type = UPDATE_PROFILE_TRAVELLER;
  constructor(public payload: any) {}
}

export class UpdateProfileTravellerSuccess implements Action {
  readonly type = UPDATE_PROFILE_TRAVELLER_SUCCESS;
  constructor(public payload: IMemberProfileTraveller) {}
}

export class UpdateProfileTravellerFail implements Action {
  readonly type = UPDATE_PROFILE_TRAVELLER_FAIL;
}

export class UpdateMultipleProfileTraveller implements Action {
  readonly type = UPDATE_MULTIPLE_PROFILE_TRAVELLER;
  constructor(public payload: any) {}
}

export type MemberProfileTravellersAction =
  | CreateProfileTraveller
  | CreateProfileTravellerSuccess
  | CreateProfileTravellerFail
  | DestroyProfileTraveller
  | DestroyProfileTravellerSuccess
  | DestroyProfileTravellerFail
  | UpdateProfileTraveller
  | UpdateProfileTravellerSuccess
  | UpdateProfileTravellerFail
  | UpdateMultipleProfileTraveller;
